import React from 'react';
import {
  Column,
  DropdownButtonCell,
  DropdownButtonCellComponentProps,
  DropdownButtonSkeleton,
  getFixedWidthFaIcon,
} from '@odin-labs/components';
import { faTrash, faWrench } from 'components/icons';
import { EditableGateway } from 'containers/jobsiteConfiguration/components/gateways/modals';

export type GatewayColumn = Column<EditableGateway>;

const WrenchIcon = getFixedWidthFaIcon({ icon: faWrench });
const TrashIcon = getFixedWidthFaIcon({ icon: faTrash });

export const getColumns = ({
  openEditModal,
  openDeleteModal,
}: {
  openEditModal: (gateway: EditableGateway) => void;
  openDeleteModal: (gateway: EditableGateway) => void;
}): GatewayColumn[] => [
  {
    id: 'name',
    Header: 'Name',
    accessor: 'name',
  },
  {
    id: 'actions',
    Header: '',
    Cell: DropdownButtonCell,
    CellLoading: (): React.ReactElement => (
      <DropdownButtonSkeleton cellAlignment="right" />
    ),
    componentProps: (
      gateway: EditableGateway,
    ): DropdownButtonCellComponentProps => ({
      cellAlignment: 'right',
      menuItems: [
        [
          {
            icon: WrenchIcon,
            text: 'Rename Gateway',
            theme: 'secondary',
            onClick: (): void => openEditModal(gateway),
          },
          {
            icon: TrashIcon,
            text: 'Delete Gateway',
            theme: 'danger',
            onClick: (): void => openDeleteModal(gateway),
          },
        ],
      ],
    }),
  },
];
